import { Injectable } from '@angular/core';
import { map, Observable, BehaviorSubject, finalize } from 'rxjs';

import { MainHttpService } from './main-http.service';

import { ITenantStatisticsModelData, TenantStatisticsModel } from '../models/tenant.model';

import { DashboardConfig } from '../configs/dashboard.config';

@Injectable({
  providedIn: 'root'
})
export class TenantService {

  isTenantStatisticsLoadingSubject: BehaviorSubject<boolean>;

  userCount$: Observable<boolean>;
  userCountSubject: BehaviorSubject<boolean>;

  constructor(
    private mainHttpService: MainHttpService
  ) {
    this.isTenantStatisticsLoadingSubject = new BehaviorSubject<boolean>(false);
  
    this.userCountSubject = new BehaviorSubject<boolean>(false);
    this.userCount$ = this.userCountSubject.asObservable();
  }

  get isTenantStatisticsLoading$(): Observable<boolean> {
    return this.isTenantStatisticsLoadingSubject.asObservable();
  }

  get statisticsItems(): any[] {
    return DashboardConfig.statisticItems;
  }

  getTenantStatistics(): Observable<TenantStatisticsModel> {
    this.isTenantStatisticsLoadingSubject.next(true);

    return this.mainHttpService.getTenantStatistics().pipe(
      map((tenantStatistics: ITenantStatisticsModelData) => {
        if (!tenantStatistics?.result) {
          throw Error("Unable to retrieve tenant statistics");
        }

        return tenantStatistics.result;

      }),
      finalize(() => this.isTenantStatisticsLoadingSubject.next(false))
    );
  }
}
